export default function FAQRenderer({ section }){

    return(

        <div>

            {(section.value || []).map((faq,index)=>(

                <div key={index} className="faq-item">

                    <h4>{faq.question}</h4>

                    <p>{faq.answer}</p>

                </div>

            ))}

        </div>

    );

}